import { render, staticRenderFns } from "./Adminitration_Producer.vue?vue&type=template&id=e8b4bc5c"
import script from "./Adminitration_Producer.vue?vue&type=script&lang=js"
export * from "./Adminitration_Producer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports